import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  CustomResultOfPaginatedListOfGetDiscountsWithPaginationDto,
  GetDiscountsWithPaginationDto,
  GetEnumValuesDto,
  PaginatedListOfGetDiscountsWithPaginationDto,
} from './../../../core/api/models';
import { GetDiscountByIdDto } from './../../../core/api/models/get-discount-by-id-dto';
import { DiscountService } from './../../../core/api/services';
import { EventTypes } from './../../../core/constants/event-types';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { BaseIndexPageComponent } from './../../../pages/shared/base/components/base-index-page.component';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { DiscountFormComponent } from "./discount-form/discount-form.component";

@Component({
    selector: 'app-discount',
    templateUrl: './discount.component.html',
    styleUrls: ['./discount.component.scss'],
    imports: [BaseIndexModule, DiscountFormComponent]
})
export class DiscountComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.discount;

  /* Binding Service Endpoints */
  protected currentService = inject(DiscountService);
  paginationApiMethodName: string = this.currentService.discountGetDiscountsWithPagination.name;
  createGetApiMethodName: string = this.currentService.discountCreateGet.name;
  auditApiMethodName: string = this.currentService.discountGetDiscountsAuditWithPagination.name;
  useAuditApiMethodName: string = this.currentService.discountGetDiscountUseAuditsWithPagination.name;

  modelWithPagination$: Observable<PaginatedListOfGetDiscountsWithPaginationDto>;
  items$: Observable<Array<GetDiscountsWithPaginationDto>>;
  formPageConfig: FormPageConfig<GetDiscountByIdDto> = {};
  DiscountTypeValues: GetEnumValuesDto[] = [];
  isShowDiscountUseAudit: boolean = false;
  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAuditBtn = false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('DiscountType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.DiscountTypeValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      // { title: this.localizer.id, name: 'id', hasSearch: true, type: "number" },
      {
        title: `${this.tableVocabs}discountCode`,
        name: 'discountCode',
        hasSearch: true,
        wrap: true,
        dir: 'ltr',
      },
      {
        title: `${this.tableVocabs}discountType`,
        name: 'discountType',
        hasSearch: true,
        type: 'enum',
        enumName: 'DiscountType',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}isPercentage`,
        name: 'isPercentage',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}discountValue`,
        name: 'discountValue',
        hasSearch: true,
        type: 'number',
        wrap: true,
      },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}specialOrganization`,
        name: 'specialOrganizationName',
        hasSearch: true,
        wrap: true,
      },
      {
        title: `${this.tableVocabs}maximumAmount`,
        name: 'maximumAmount',
        hasSearch: true,
        needCurrency: true,
        type: 'number',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}maximumUse`,
        name: 'maximumUse',
        hasSearch: true,
        type: 'number',
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'dateStart',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
      {
        title: this.localizer.expireDate,
        name: 'dateExpire',
        hasSearch: true,
        type: 'dateTime',
        wrap: true,
      },
    ];
  }

  //#region api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;
    this.formPageConfig.editId = id;

    this.currentService
      .discountUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .discountDelete({ body: { id: id } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //#endregion

  onShowDiscountUseAuditPage() {
    this.isShowDiscountUseAudit = true;
  }
}
